(function() {
  'use strict';
  if (!window.zcCartExperiment) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  var cached = new Map();
  var refreshTimer = 0;
  var latestRun = 0;
  // One offer at a time: hide while a marked upsell line remains in the
  // CURRENT cart. Never carry a stale suppression across an emptied basket.
  function clearAcceptance() {
    window.zcCartExperiment.upsellAccepted = false;
    document.documentElement.removeAttribute('data-zc-upsell-accepted');
    try { localStorage.removeItem('zc_cart_upsell_accepted_v1'); } catch(e) {}
  }
  function acceptedForCart(cart) {
    var accepted = !!(cart && Array.isArray(cart.items) &&
      cart.items.some(function(item) {
        return item.properties &&
          item.properties._zaltify_cart_upsell === 'cart_cro_v1';
      }));
    if (accepted) {
      window.zcCartExperiment.upsellAccepted = true;
      document.documentElement.setAttribute('data-zc-upsell-accepted','true');
    } else {
      clearAcceptance();
    }
    return accepted;
  }

  var config = {
    'zalto-burgundy-glass': ['zalto-white-wine-glass','zalto-champagne-glass','zalto-bordeaux-glass','zalto-universal-glass','zalto-balance-glass','zalto-coupe-crystal-clear'],
    'zalto-bordeaux-glass': ['zalto-burgundy-glass','zalto-white-wine-glass','zalto-champagne-glass','zalto-universal-glass','zalto-balance-glass','zalto-coupe-crystal-clear'],
    'zalto-universal-glass': ['zalto-burgundy-glass','zalto-white-wine-glass','zalto-champagne-glass','zalto-bordeaux-glass','zalto-balance-glass','zalto-coupe-crystal-clear'],
    'zalto-balance-glass': ['zalto-universal-glass','zalto-burgundy-glass','zalto-white-wine-glass','zalto-champagne-glass','zalto-bordeaux-glass','zalto-coupe-crystal-clear']
  };
  // Manually curated strong matches, not an unrestricted free-shipping search.
  // Only a product within the first TWO positions can be promoted for shipping.
  // Product affinity, curated for what complements the actual glass in cart.
  // Shipping is a modest tie-breaker, never the primary reason to recommend.
  var highAffinity = {
    'zalto-universal-glass': ['zalto-burgundy-glass','zalto-white-wine-glass','zalto-champagne-glass','zalto-gravitas-omega','zalto-bordeaux-glass'],
    'zalto-burgundy-glass': ['zalto-universal-glass','zalto-mystique','zalto-bordeaux-glass','zalto-white-wine-glass','zalto-gravitas-omega'],
    'zalto-bordeaux-glass': ['zalto-mystique','zalto-universal-glass','zalto-burgundy-glass','zalto-gravitas-omega'],
    'zalto-white-wine-glass': ['zalto-universal-glass','zalto-champagne-glass','zalto-burgundy-glass'],
    'zalto-champagne-glass': ['zalto-white-wine-glass','zalto-universal-glass','zalto-coupe-crystal-clear'],
    'zalto-balance-glass': ['zalto-universal-glass','zalto-bordeaux-glass','zalto-burgundy-glass','zalto-gravitas-omega'],
    'zalto-gravitas-omega': ['zalto-universal-glass','zalto-burgundy-glass','zalto-bordeaux-glass']
  };
  var fallback = ['zalto-universal-glass','zalto-burgundy-glass','zalto-white-wine-glass','zalto-champagne-glass','zalto-bordeaux-glass','zalto-balance-glass','zalto-coupe-crystal-clear'];
  var carafeRecommendations = {
    'zalto-mystique':['zalto-bordeaux-glass','zalto-burgundy-glass','zalto-universal-glass','zalto-white-wine-glass'],
    'zalto-axium-decanter':['zalto-universal-glass','zalto-bordeaux-glass','zalto-burgundy-glass','zalto-white-wine-glass'],
    'zalto-carafe-no-25':['zalto-white-wine-glass','zalto-universal-glass','zalto-burgundy-glass','zalto-champagne-glass'],
    'zalto-carafe-no-75':['zalto-white-wine-glass','zalto-universal-glass','zalto-burgundy-glass','zalto-champagne-glass'],
    'zalto-carafe-no-150':['zalto-white-wine-glass','zalto-universal-glass','zalto-burgundy-glass','zalto-champagne-glass'],
    'zalto-carafe-67':['zalto-universal-glass','zalto-white-wine-glass','zalto-burgundy-glass','zalto-champagne-glass']
  };
  function isCarafe(handle) {
    return Object.prototype.hasOwnProperty.call(carafeRecommendations,handle) || /carafe|decanter|mystique/i.test(handle);
  }
  function isGlass(handle) {
    return /glass|coupe/i.test(handle);
  }
  function cartCategory(handles) {
    var glass=false,carafe=false;
    handles.forEach(function(h){if(isCarafe(h))carafe=true;else if(isGlass(h))glass=true;});
    if (glass && carafe) return 'mixed';
    if (carafe) return 'carafe';
    if (glass) return 'glasses';
    return 'other';
  }
  function getProduct(handle) {
    if (!cached.has(handle)) {
      cached.set(handle, fetch(root+'products/'+handle+'.js', {credentials:'same-origin',headers:{'Accept':'application/json'}})
        .then(function(r){if(!r.ok)throw new Error('Product '+handle+' unavailable');return r.json();})
        .catch(function(e){cached.delete(handle);throw e;}));
    }
    return cached.get(handle);
  }
  function selectCandidates(handles) {
    var result=[];
    // If the basket contains a decanter, complement it with appropriate glasses.
    handles.forEach(function(h){
      if(isCarafe(h)&&carafeRecommendations[h]) result.push(...carafeRecommendations[h]);
    });
    // More specific red wine choices win over a generic Universal in mixed carts.
    var priority=['zalto-bordeaux-glass','zalto-burgundy-glass',
      'zalto-white-wine-glass','zalto-champagne-glass','zalto-balance-glass',
      'zalto-universal-glass','zalto-gravitas-omega'];
    var primary=priority.find(function(h){return handles.has(h);});
    if(primary && highAffinity[primary]) result.push(...highAffinity[primary]);
    result.push(...fallback);
    return [...new Set(result)].filter(function(h){return !handles.has(h);});
  }
  function visitedProducts() {
    try {
      return (window.zcCartInterest && window.zcCartInterest.recent()) || [];
    } catch(e) {return [];}
  }
  function candidateScore(candidate,rank,history,cart,card) {
    var score=100-rank*15;
    var lastViewed=history.indexOf(candidate.handle);
    if(lastViewed>=0)score+=Math.max(45,85-lastViewed*8);
    if(rank<=1 && unlocksFreeShipping(cart,candidate.variant,card))score+=4;
    return score;
  }

  function unlocksFreeShipping(cart,variant,card) {
    if(!cart || !variant || !card) return false;
    var country=card.getAttribute('data-zc-country') || '';
    var current=Number(cart.total_price);
    var candidatePrice=Number(variant.price);
    // The existing shipping promise is a 200 EUR discounted basket threshold.
    // Don't promise free shipping when existing discounts may also reduce
    // the recommended product's effective price.
    return cart.currency === 'EUR' && country!=='DK' &&
      Number(cart.total_discount || 0)===0 &&
      Number.isFinite(current) && Number.isFinite(candidatePrice) &&
      current>0 && current<20000 && candidatePrice>0 &&
      current+candidatePrice>=20000;
  }
  function pickVariant(product,handle) {
    // Mystique is a single decanter. Other recommendations remain 2-packs.
    if(handle==='zalto-mystique'){
      return (product.variants||[]).find(function(v){
        return v.available===true && String(v.sku||'').endsWith('-01');
      }) || (product.variants||[]).find(function(v){return v.available===true;});
    }
    return (product.variants||[]).find(function(v){
      var sku=String(v.sku||'');
      var name=String(v.public_title||v.title||'').toLowerCase();
      return v.available===true && (sku.endsWith('-02') ||
        /(?:^|[^a-z0-9])2[\s-]?(?:pack|pak|pcs|stk|er|glasses|verres|bicchieri|copas|kpl)/i.test(name));
    });
  }
  async function candidateDetails(handle) {
    try {
      var product=await getProduct(handle);
      var variant=pickVariant(product,handle);
      if(!variant || !(product.featured_image || product.images?.[0]))return null;
      return {handle:handle,product:product,variant:variant};
    }catch(e){
      // Do not show an unavailable, unpublished or out-of-stock product.
      return null;
    }
  }

  function formatPrice(cents, currency) {
    try {return new Intl.NumberFormat(document.documentElement.lang||'en', {style:'currency',currency:currency}).format(cents/100);}
    catch(e){return (cents/100).toFixed(2)+' '+currency;}
  }
  async function renderCard(card, cart, runId) {
    card.hidden = true;
    if(!cart || !cart.items || !cart.items.length) {
      acceptedForCart(cart);
      return;
    }
    if (acceptedForCart(cart)) return;
    var handles = new Set(cart.items.map(function(i) {return i.handle || (i.url||'').split('/products/')[1]?.split('?')[0];}).filter(Boolean));
    var category = cartCategory(handles);
    var heading = card.getAttribute('data-zc-title-' + category) || card.getAttribute('data-zc-title-other');
    card.setAttribute('aria-label',heading);
    var headingNode = card.querySelector('[data-zc-upsell-heading]');
    if (headingNode) headingNode.textContent = heading;
    var imageLink = card.querySelector('[data-zc-upsell-link]');
    if (imageLink) imageLink.setAttribute('aria-label',heading);
    var candidates=selectCandidates(handles);
    var history=visitedProducts();
    // Fetch the top three relevant products, plus at most two distinctly
    // visited relevant products. Avoid a long serial chain and extra requests.
    var visitedEligible=history.filter(function(h){
      return candidates.indexOf(h)>=0 && candidates.indexOf(h)<7;
    }).slice(0,2);
    var shortlist=[...new Set(candidates.slice(0,3).concat(visitedEligible))].slice(0,5);
    var results=await Promise.all(shortlist.map(candidateDetails));
    if(runId!==latestRun || !card.isConnected)return;
    var scored=results.filter(Boolean).map(function(c){
      return {item:c,score:candidateScore(c,candidates.indexOf(c.handle),history,cart,card)};
    }).sort(function(a,b){return b.score-a.score;});
    var chosen=scored.length?scored[0].item:null;
    // Falling back never forces unrelated free-shipping products.
    if(!chosen){
      for(var i=3;i<candidates.length;i++){
        if(runId!==latestRun || !card.isConnected)return;
        chosen=await candidateDetails(candidates[i]);
        if(chosen)break;
      }
    }
    if(chosen) {
      var product=chosen.product;
      var variant=chosen.variant;
      var href=root+'products/'+encodeURIComponent(chosen.handle);
      var photo=product.featured_image||product.images[0];
      card.querySelector('[data-zc-upsell-image]').src=photo;
      card.querySelector('[data-zc-upsell-image]').alt=product.title;
      card.querySelector('[data-zc-upsell-link]').href=href;
      card.querySelector('[data-zc-upsell-title]').href=href;
      card.querySelector('[data-zc-upsell-title]').textContent=product.title;
      card.querySelector('[data-zc-upsell-price]').textContent=formatPrice(variant.price,cart.currency||'EUR');
      var btn=card.querySelector('[data-zc-upsell-add]');
      btn.setAttribute('data-variant-id',variant.id);
      btn.disabled=false;
      var packLabel=card.querySelector('[data-zc-upsell-pack]');
      if(packLabel)packLabel.textContent=card.getAttribute(
        chosen.handle==='zalto-mystique'?'data-zc-single-label':'data-zc-pack-label'
      ) || (chosen.handle==='zalto-mystique'?'1 decanter':'2-pack');
      var badge=card.querySelector('[data-zc-upsell-free-shipping]');
      if(badge)badge.hidden=!unlocksFreeShipping(cart,variant,card);
      card.hidden=false;
      card.setAttribute('data-zc-upsell-product',chosen.handle);
      return;
    }
    // Keep module hidden rather than offering out-of-stock/unavailable products.
    console.info('[Zaltify cart CRO] No available recommendation for current cart.');
  }
  async function refresh() {
    if(window.zcCartExperiment?.group!=='treatment') return;
    var card=document.querySelector('cart-drawer-component [data-zc-upsell-shell]');
    if(!card)return;
    var runId=++latestRun;
    try {
      var response=await fetch(root+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
      if(!response.ok)throw new Error('Cart unavailable');
      var cart=await response.json();
      if(runId!==latestRun)return;
      await renderCard(card,cart,runId);
    } catch(e) {console.warn('[Zaltify cart CRO] Unable to load recommendation',e);}
  }
  function queueRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer=setTimeout(refresh,90);
  }
  function start() {
    queueRefresh();
    // Horizon dynamically replaces the cart drawer markup after cart changes.
    var observer=new MutationObserver(function(records){
      var hasNewShell=records.some(function(record){
        return Array.from(record.addedNodes).some(function(node){
          return node.nodeType===1 && (node.matches?.('[data-zc-upsell-shell]') || node.querySelector?.('[data-zc-upsell-shell]'));
        });
      });
      if(hasNewShell)queueRefresh();
    });
    observer.observe(document.body,{childList:true,subtree:true});
    document.addEventListener('zaltify:cart-upsell-accepted', function(){
      // Immediate feedback. Subsequent cart.js refresh verifies the line marker.
      window.zcCartExperiment.upsellAccepted = true;
      document.documentElement.setAttribute('data-zc-upsell-accepted','true');
    });
    document.addEventListener('zaltify:product-interest-updated',queueRefresh);
    document.addEventListener('cart:update',function(event){
      // Clearing the basket resets the one-upsell limit for the next basket.
      if (event.detail?.resource?.item_count === 0) clearAcceptance();
      setTimeout(queueRefresh,150);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start);
  else start();
})();